module.exports = __webpack_public_path__ + "static/media/purityx-3.8396b95e.png";